namespace Ir.Components.Filters.TextBoxFilter {
    interface ITextBoxFilterViewModel {
        filter: Filter;
        textBoxSettings: DevExpress.ui.dxTextBox.Properties;
        textBoxComponent: DevExpress.ui.dxTextBox;
        nullButtonParams: Ir.Components.Filters.NullButton.INullButtonParams;
    }

    export function getViewModel(this: ITextBoxFilterViewModel, params: IFilterParameterVM) {
        let self = this;
        this.filter = params.filter;

        this.filter.startDisplayCondition(this.filter.startCondition() === null ? irSettings.nullText : this.filter.startCondition());
        this.textBoxSettings = {
            disabled: ko.computed(function () {
                return self.filter.readOnly();
            }) as any,
            value: this.filter.startCondition as any,
            valueChangeEvent: "keyup",
            onInitialized(e) {
                self.textBoxComponent = e.component;
            },
            onValueChanged(data) {
                if (data.previousValue !== data.value) {
                    self.filter.startCondition(data.value)
                    self.filter.startDisplayCondition(data.value);
                    self.filter.publish();
                }
            }
        }

        this.filter.clearFilter = function (this: Filter) {
            this.startCondition("");
        };

        this.nullButtonParams = {
            filter: this.filter,
            onItemClick(e) {
                if (self.filter.startCondition() === null) {
                    self.filter.startCondition("");
                    self.filter.startDisplayCondition("");
                }
                else {
                    self.filter.conditionType(FilterConditionTypeEnum.Equals);
                    self.filter.startCondition(null);
                    self.filter.startDisplayCondition(irSettings.nullText);
                }

                self.filter.publish();
                self.textBoxComponent.element().focus();
            }
        };
    }
}